<div class="flex flex-col justify-between h-full">
  <!-- Form Content -->
  <div class="p-6" [formGroup]="form">
    <app-form-card title="Recipient" icon="Mail">
      <app-form-field
        label="Email address"
        hint="All documents currently on this load will be attached."
      >
        <app-input
          formControlName="email"
          type="email"
          placeholder="name@example.com"
          prefixIcon="Mail"
        ></app-input>
      </app-form-field>
    </app-form-card>
  </div>
  <!-- Modal Actions -->
  <div
    class="flex flex-col-reverse lg:flex-row justify-end gap-3 p-2 md:p-4 border-t border-border"
  >
    <app-button variant="secondary" (click)="cancel()" [disabled]="isSaving()">
      Cancel
    </app-button>
    <app-button
      (click)="send()"
      [disabled]="form.invalid || isSaving()"
      [loading]="isSaving()"
    >
      {{ isSaving() ? "Sending..." : "Send Documents" }}
    </app-button>
  </div>
</div>
